import { Flex, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSuperadminAuth } from '../context/SuperadminAuthContext';
import { fi, gb, i18n, sv } from '@shared';
import { useUpdateUser } from '../api/hooks/useUserSuperadmin';

const UNSELECTED_LANGUAGE_OPACITY = 0.3;
export function LanguageSelector() {
	const { i18n: i18nextInstance } = useTranslation();
	const language = i18nextInstance.language;

	const { mutate } = useUpdateUser();
	const { user } = useSuperadminAuth();

	function handleChangeLanguage(selected: 'en' | 'fi' | 'sv'): void {
		i18n.changeLanguage(selected);

		if (!user) {
			return;
		}

		const payload = {
			userID: user?.userID,
			language: selected,
		};

		mutate(payload);
	}

	return (
		<Flex justifyContent="center" gap={3} alignItems={'center'}>
			<Image
				data-cy="finnishLanguage"
				boxShadow={'0px 4px 4px 0px rgba(0, 0, 0, 0.25)'}
				src={fi}
				alt="Finnish"
				onClick={() => handleChangeLanguage('fi')}
				opacity={language === 'fi' ? 1 : UNSELECTED_LANGUAGE_OPACITY}
				cursor={'pointer'}
				height={'20px'}
			/>
			<Image
				data-cy="englishLanguage"
				boxShadow={'0px 4px 4px 0px rgba(0, 0, 0, 0.25)'}
				src={gb}
				alt="English"
				onClick={() => handleChangeLanguage('en')}
				opacity={language === 'en' ? 1 : UNSELECTED_LANGUAGE_OPACITY}
				cursor={'pointer'}
				height={'20px'}
			/>
			<Image
				data-cy="swedishLanguage"
				boxShadow={'0px 4px 4px 0px rgba(0, 0, 0, 0.25)'}
				src={sv}
				alt="Swedish"
				onClick={() => handleChangeLanguage('sv')}
				opacity={language === 'sv' ? 1 : UNSELECTED_LANGUAGE_OPACITY}
				cursor={'pointer'}
				height={'20px'}
			/>
		</Flex>
	);
}
